import { render } from "./login-account.vue?vue&type=template&id=32d0cb81&scoped=true&ts=true"
import script from "./login-account.vue?vue&type=script&lang=ts"
export * from "./login-account.vue?vue&type=script&lang=ts"

import "./login-account.vue?vue&type=style&index=0&id=32d0cb81&scoped=true&lang=less"

import exportComponent from "/opt/build/repo/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-32d0cb81"]])

export default __exports__